"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Basket = _interopRequireDefault(require("../model/Basket"));
var _Message = _interopRequireDefault(require("../model/Message"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Basket service.
* @module api/BasketApi
* @version 3.0
*/
var BasketApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new BasketApi. 
  * @alias module:api/BasketApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function BasketApi(apiClient) {
    _classCallCheck(this, BasketApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Create Basket
   * Creates an empty Basket for the User.<br>Items are then placed into the Basket using a Basket object with a PUT.<br>Once confirmed the Basket becomes a ConfirmedBasket.<br>Baskets are confirmed with an idempotent PUT (the Basket on the PUT payload has same contents as the existing basket). <br>Payments can only happen on a ConfirmedBasket.<br>
   * @param {Number} userId User ID the basket is for
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Basket} and HTTP response
   */
  return _createClass(BasketApi, [{
    key: "createBasketWithHttpInfo",
    value: function createBasketWithHttpInfo(userId) {
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling createBasket");
      }
      var pathParams = {
        'userId': userId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Basket["default"];
      return this.apiClient.callApi('/users/{userId}/baskets', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create Basket
     * Creates an empty Basket for the User.<br>Items are then placed into the Basket using a Basket object with a PUT.<br>Once confirmed the Basket becomes a ConfirmedBasket.<br>Baskets are confirmed with an idempotent PUT (the Basket on the PUT payload has same contents as the existing basket). <br>Payments can only happen on a ConfirmedBasket.<br>
     * @param {Number} userId User ID the basket is for
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Basket}
     */
  }, {
    key: "createBasket",
    value: function createBasket(userId) {
      return this.createBasketWithHttpInfo(userId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a specific Basket.
     * Gets a specific basket based on the basketId
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Basket} and HTTP response
     */
  }, {
    key: "getBasketWithHttpInfo",
    value: function getBasketWithHttpInfo(userId, basketId) {
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getBasket");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling getBasket");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Basket["default"];
      return this.apiClient.callApi('/users/{userId}/baskets/{basketId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a specific Basket.
     * Gets a specific basket based on the basketId
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Basket}
     */
  }, {
    key: "getBasket",
    value: function getBasket(userId, basketId) {
      return this.getBasketWithHttpInfo(userId, basketId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Lists the Baskets of a User
     * Returns a list of all Baskets where the User matches the given userId
     * @param {Number} userId User ID the basket is for
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Basket>} and HTTP response
     */
  }, {
    key: "getBasketsWithHttpInfo",
    value: function getBasketsWithHttpInfo(userId) {
      var postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling getBaskets");
      }
      var pathParams = {
        'userId': userId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Basket["default"]];
      return this.apiClient.callApi('/users/{userId}/baskets', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Lists the Baskets of a User
     * Returns a list of all Baskets where the User matches the given userId
     * @param {Number} userId User ID the basket is for
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Basket>}
     */
  }, {
    key: "getBaskets",
    value: function getBaskets(userId) {
      return this.getBasketsWithHttpInfo(userId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modify a Basket.
     * Adds the contents of the body into the Basket.<br>This can also be used to remove items from the Basket.<br>Products can be added to a Customer, Account or Service using the specific arrays.<br>Product Instances can be removed from a Customer, Account or Service level using the delItem arrays.<br>Once confirmed the Basket becomes a ConfirmedBasket.<br>Baskets are confimed with an idempotent PUT (the Basket on the PUT payload has same contents as the existing Basket).<br>A HATEOAS link will be provided for the ConfirmedBasket.<br>Payments can only happen on a ConfirmedBasket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @param {module:model/Basket} basket A basket details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Basket} and HTTP response
     */
  }, {
    key: "modifyBasketWithHttpInfo",
    value: function modifyBasketWithHttpInfo(userId, basketId, basket) {
      var postBody = basket;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling modifyBasket");
      }
      // verify the required parameter 'basketId' is set
      if (basketId === undefined || basketId === null) {
        throw new Error("Missing the required parameter 'basketId' when calling modifyBasket");
      }
      // verify the required parameter 'basket' is set
      if (basket === undefined || basket === null) {
        throw new Error("Missing the required parameter 'basket' when calling modifyBasket");
      }
      var pathParams = {
        'userId': userId,
        'basketId': basketId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Basket["default"];
      return this.apiClient.callApi('/users/{userId}/baskets/{basketId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modify a Basket.
     * Adds the contents of the body into the Basket.<br>This can also be used to remove items from the Basket.<br>Products can be added to a Customer, Account or Service using the specific arrays.<br>Product Instances can be removed from a Customer, Account or Service level using the delItem arrays.<br>Once confirmed the Basket becomes a ConfirmedBasket.<br>Baskets are confimed with an idempotent PUT (the Basket on the PUT payload has same contents as the existing Basket).<br>A HATEOAS link will be provided for the ConfirmedBasket.<br>Payments can only happen on a ConfirmedBasket.<br>
     * @param {Number} userId User ID the basket is for
     * @param {Number} basketId Basket ID
     * @param {module:model/Basket} basket A basket details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Basket}
     */
  }, {
    key: "modifyBasket",
    value: function modifyBasket(userId, basketId, basket) {
      return this.modifyBasketWithHttpInfo(userId, basketId, basket).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();